<template>
    <div class="d-flex justify-content-center justify-content-md-start">
        <div v-for="(readableType, type) in types"
             class="border rounded px-5 pt-2 pb-1 cursor-pointer mr-2"
             :class="{'bg-primary text-white': isSelected(type)}"
             style="white-space: nowrap"
             @click="$emit('input', type)"
        >
            <i v-if="isSelected(type)" class="fas fa-check-circle text-white"/>
            <i v-else class="fas fa-circle text-muted"/>
            <span class="pl-1">{{ readableType }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
    },

    data() {
        return {
            types: {
                'slider': __('offers.widget.layout.slider'),
                'grid': __('offers.widget.layout.grid'),
            },
        }
    },

    methods: {
        isSelected(type) {
            return type === this.value
        },
    },
}
</script>
